import { FunctionComponent, useState } from 'react'
import styles from './levels.module.scss'
import { TableCell, TableRow } from '@mui/material'
import { Delete } from '@mui/icons-material'
import { StaffLevel } from '@/types/StaffLevel'
import Checkbox from '@/components/_custom/Checkbox/Checkbox'
import { Daycare } from '@/types/Daycare'
import EditIcon from '@mui/icons-material/Edit'
import StaffLevelDialog from './Dialog/staffLevelDialog'
import ValidDeleteStaffLevelDialog from './Dialog/validDeleteStaffLevelDialog'

interface LevelRowProps {
    level: StaffLevel
    daycare: Daycare
    canUpdate: boolean
    removeOneStaffLevel: (levelId: number) => void
    updateOneStaffLevel: (level: StaffLevel) => void
}

const LevelRow: FunctionComponent<LevelRowProps> = ({
    level,
    daycare,
    canUpdate,
    removeOneStaffLevel,
    updateOneStaffLevel
}: LevelRowProps) => {
    const [levelName, setLevelName] = useState<string>(level.name)
    const [levelRequired, setLevelRequired] = useState<boolean>(level.required)

    const [isDeleteLevelDialogOpen, setDeleteLevelDialogOpen] = useState<boolean>(false)
    const [isUpdateLevelDialogOpen, setUpdateLevelDialogOpen] = useState<boolean>(false)

    return (
        <>
            <TableRow>
                <TableCell>{levelName}</TableCell>
                <TableCell align={'center'}>
                    <Checkbox checked={levelRequired} disabled className={styles.CheckBox} />
                </TableCell>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={() => setUpdateLevelDialogOpen(true)} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={() => setDeleteLevelDialogOpen(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <StaffLevelDialog
                open={isUpdateLevelDialogOpen}
                handleClose={() => setUpdateLevelDialogOpen(false)}
                create={false}
                daycare={daycare}
                staffLevelId={level.id}
                staffLevelName={levelName}
                setStaffLevelName={setLevelName}
                staffLevelRequired={levelRequired}
                setStaffLevelRequired={setLevelRequired}
                updateOneStaffLevel={updateOneStaffLevel}
            />
            <ValidDeleteStaffLevelDialog
                open={isDeleteLevelDialogOpen}
                handleClose={() => setDeleteLevelDialogOpen(false)}
                staffLevelId={level.id}
                daycareId={daycare.id}
                removeOneStaffLevel={removeOneStaffLevel}
            />
        </>
    )
}

export default LevelRow
